"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const getState_1 = require("../../helpers/getState");
const getScaledScoreForRawScore_1 = require("./getScaledScoreForRawScore");
const getSuccessStatusForLeafNode_1 = require("./getSuccessStatusForLeafNode");
const isGradable_1 = require("./isGradable");
/**
 * Updates rawScore, scaledScore and successStatus fields
 * using (successCriteria + completionStatus +
 * allQuestionsGraded)
 */
function updateSuccessStatusFieldsForAssignmentCard(state, user, content, allStates) {
    if (state.forceComplete) {
        return;
    }
    const gradableQuestions = content.children.filter((questionContent) => isGradable_1.isGradable(questionContent));
    const childrenStates = getState_1.getChildrenStatesForContentByUserId(allStates, content, user.userId);
    const childrenStatesByContentId = keyBy_1.default(childrenStates, 'contentId');
    let allQuestionsGraded = true;
    let totalRawScore = 0;
    let totalMinScore = 0;
    let totalMaxScore = 0;
    gradableQuestions.forEach((questionContent) => {
        const childContentId = questionContent._id;
        const questionState = childrenStatesByContentId[childContentId];
        if (questionContent.content.gradingScheme === 'peerGradable') {
            const reviewReceivedCount = questionState.reviewsReceivedCount;
            const reviewsRequired = questionContent.minGetReviewedCount;
            if (reviewReceivedCount < reviewsRequired) {
                allQuestionsGraded = false;
            }
        }
        else if (questionContent.content.gradingScheme === 'teacherGradable') {
            const gradedBy = questionState.submissions[0].gradedBy;
            if (!gradedBy) {
                allQuestionsGraded = false;
            }
        }
        totalRawScore += questionState.rawScore;
        totalMinScore += questionContent.minScore;
        totalMaxScore += questionContent.maxScore;
    });
    state.rawScore = totalRawScore;
    state.scaledScore = getScaledScoreForRawScore_1.getScaledScoreForRawScore(totalRawScore, totalMinScore, totalMaxScore);
    state.successStatus = getSuccessStatusForLeafNode_1.getSuccessStatusForLeafNode(content.successCriteria, state.scaledScore, content.minScaledScore, state.completionStatus, allQuestionsGraded);
}
exports.updateSuccessStatusFieldsForAssignmentCard = updateSuccessStatusFieldsForAssignmentCard;
//# sourceMappingURL=updateSuccessStatusFieldsForAssignmentCard.js.map